import React, { Children } from "react"
import cx from "classnames"

import GhostButton from "./GhostButton"
import InversedButton from "./InversedButton"
import DefaultButton from "./DefaultButton"
import { AllButtonsPropsType } from "./"
import Button from "./Button"

export interface ButtonsGroupProps {
  className?: string
  children: React.ReactNode
  align?: "fullWidth" | "right" | "center"
}

const isButton = (
  component: React.ReactNode
): component is React.ReactElement<AllButtonsPropsType> =>
  React.isValidElement(component) &&
  (component.type === GhostButton ||
    component.type === GhostButton.Link ||
    component.type === InversedButton ||
    component.type === InversedButton.Link ||
    component.type === DefaultButton ||
    component.type === DefaultButton.Link ||
    component.type === Button)

const ButtonsGroup = ({ className, children, align }: ButtonsGroupProps) => (
  <div
    className={cx(className, "cobalt-buttons-group", {
      "cobalt-buttons-group--right": align === "right",
      "cobalt-buttons-group--center": align === "center",
    })}
  >
    {Children.toArray(children).map((child, index) =>
      isButton(child)
        ? React.cloneElement(child, {
            key: index,
            className: cx("cobalt-buttons-group__item", {
              "cobalt-buttons-group__item--fullWidth": align === "fullWidth",
            }),
            fullWidth: align === "fullWidth",
          })
        : child
    )}
  </div>
)

export default ButtonsGroup
